import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { CalendarIcon } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Shadcn Calendar + Popover wrapper.
 * Value: ISO string "YYYY-MM-DD"; onChange(iso)
 */
export function DatePicker({ value, onChange, className, testId }) {
  const date = value ? new Date(value + "T00:00:00") : undefined;
  const label = value
    ? date.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" })
    : "Selecione uma data";
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          data-testid={testId}
          className={cn("w-full justify-start font-normal bg-background/60", !value && "text-muted-foreground", className)}
        >
          <CalendarIcon className="size-4 mr-2 text-[hsl(var(--vv-lime))]" />
          {label}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={(d) => {
            if (!d) return;
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, "0");
            const day = String(d.getDate()).padStart(2, "0");
            onChange(`${y}-${m}-${day}`);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
